import React from "react";
import Button from "@mui/material/Button";
import styled from "styled-components";

export type DlGroupFormState = {
  slug: string;
  fCondText: string;
  groupsText: string;
};

type DlGroupFormProps = {
  values?: Partial<DlGroupFormState>;
  errorText?: string;
  isEditMode?: boolean;
  onChange: (
    field: keyof DlGroupFormState,
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onReset: () => void;
};

const EMPTY_VALUES: DlGroupFormState = {
  slug: "",
  fCondText: "{}",
  groupsText: "",
};

const DlGroupForm = ({
  values,
  errorText = "",
  isEditMode = false,
  onChange,
  onSubmit,
  onReset,
}: DlGroupFormProps) => {
  const slugDefault = values?.slug ?? EMPTY_VALUES.slug;
  const fCondTextDefault = values?.fCondText ?? EMPTY_VALUES.fCondText;
  const groupsTextDefault = values?.groupsText ?? EMPTY_VALUES.groupsText;

  return (
    <DivForm>
      <form onSubmit={onSubmit}>
        <Title>{isEditMode ? "Uredi odrednicu" : "Nova odrednica"}</Title>

        <DivField>
          <label htmlFor="slug">Slug</label>
          <Input
            id="slug"
            type="text"
            placeholder="slug"
            value={slugDefault}
            onChange={onChange("slug")}
          />
        </DivField>

        <DivField>
          <label htmlFor="fCond">fCond JSON</label>
          <TextArea
            id="fCond"
            rows={8}
            value={fCondTextDefault}
            onChange={onChange("fCondText")}
          />
        </DivField>

        <DivField>
          <label htmlFor="groups">Groups</label>
          <Input
            id="groups"
            type="text"
            value={groupsTextDefault}
            onChange={onChange("groupsText")}
            placeholder="group-1, group-2"
          />
        </DivField>

        {errorText !== "" && <ErrorText>{errorText}</ErrorText>}

        <DivNav>
          <Button onClick={() => onReset()} type="button">
            Reset
          </Button>
          <Button type="submit">OK</Button>
        </DivNav>
      </form>
    </DivForm>
  );
};

const DivForm = styled.div`
  margin-top: 0.75rem;
`;

const DivField = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
`;

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

const Title = styled.h2`
  margin: 0 0 1rem;
`;

const Input = styled.input`
  width: 75%;
  padding: 0.45rem 0.6rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.95rem;
  margin-top: 0.7em;
`;

const TextArea = styled.textarea`
  width: 75%;
  padding: 0.45rem 0.6rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.95rem;
  margin-top: 0.7em;
  resize: vertical;
`;

const ErrorText = styled.div`
  margin-top: 0.5rem;
  color: #b00020;
  font-weight: 600;
`;

export default DlGroupForm;
